// common
const common = {
  'common.Cancel': '取消',
  'common.Save': '保存',
  'common.add': '添加',
  'common.operation': '操作',
  'common.modify': '修改',
  'common.Edit': '编辑',
  'common.view': '查看',
  'common.delete': '删除',
  'common.sureDelete': '您确定要删除吗？',
  'common.deleteSuccess': '删除成功',
  'common.addSuccess': '添加成功',
  'common.modifySuccess': '修改成功',
  'common.ok': '确定',
  'common.cancel': '取消',
  'common.prompt': '提示',
  'common.advSearch': '高级搜索',
  'common.customSearch': '自定义搜素'
};

// TableData
const TableData = {
  'TableData.pleaseSelectARecord': '请选择一条记录',
  'TableData.exportAll': '导出全部列',
  'TableData.sureCancelEdit': '您确定要取消编辑吗？',
  'TableData.exportSpecify': '导出指定列',
  'TableData.exportCheck': '请勾选导出项',
  'TableData.exportInput': '输入关键字搜索表格列名',
  'TableData.selectAll': '全选',
  'TableData.empty': '无数据',
  'TableData.refresh': '刷新',
  'TableData.advancedSearch': '高级搜素',
  'TableData.ok': '确认',
  'TableData.enlarge': '放大',
  'TableData.shrink': '缩小',
  'TableData.customSearch': '自定义搜素'
};

// OrgChartData
const OrgChartData = {
  'OrgChartData.setting': '设置',
  'OrgChartData.saveStructure': '保存结构',
  'OrgChartData.up': '上一层',
  'OrgChartData.down': '下一层',
  'OrgChartData.sureSaveSturcture': '您确定要保存该结构吗？'
};

const ClockInPlace = {
  'ClockInPlace.sites': '地点',
  'ClockInPlace.tips': '用户能够在指定范围内打卡',
  'ClockInPlace.addSite': '添加地点',
  'ClockInPlace.siteAddress': '地点地址',
  'ClockInPlace.fenceSize': '范围大小',
  'ClockInPlace.avaliableJobs': '可用的工作',
  'ClockInPlace.avaliableJobsTip': '确定在此状态下可以使用哪些工作',
  'ClockInPlace.allActiveSitesTitile': '所有选中地点的地图预览',
  'ClockInPlace.done': '完成',
  'ClockInPlace.addressName': '地点名称',
  'ClockInPlace.addressDetail': '地点详情',
  'ClockInPlace.selectJobs': '选择工作',
  'ClockInPlace.tipAddressName': '请输入地点名称',
  'ClockInPlace.tipJobs': '请选择可用的工作',
  'ClockInPlace.tipCities': '请选择地点地址',
  'ClockInPlace.tipAddress': '请选择地点',
};

export default {
  ...common,
  ...TableData,
  ...OrgChartData,
  ...ClockInPlace,
  add: '添加',
  edit: '编辑',
  save: '保存',
  cancel: '取消',
  view: '查看',
  modify: '修改',
  delete: '删除',
  choose: '选择'
};
